// extracted by mini-css-extract-plugin
export var container = "embed-social-media-module--container--9dd5a";
export var content = "embed-social-media-module--content--ede95";
export var linkedin = "embed-social-media-module--linkedin--bcce8";
export var twitter = "embed-social-media-module--twitter--fc6cb";
export var youtube = "embed-social-media-module--youtube--8ed03";